













































































































































































































































































































import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "ComparatorGuide",
})
export default class ComparatorGuide extends Vue {}
